module.exports = __webpack_public_path__ + "static/media/7_Peace of mind_JP.666923c1.txt";